var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 161.83 160.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M159.95,78.54c2.18,2.13,2.7,6.66.27,8.94l-28.28,17.46,29.46,30.57c.28,1.38-.46,2.2-1.09,3.27-.73,1.23-18.92,19.44-20.16,20.16-1.9,1.1-3.26,1.43-5.46,1.05-4.69-.81-24.87-25.48-30.57-29.42-1.91.04-15.49,28.39-21.23,30.06s-6.48-3.36-7.96-7.43c-10.46-28.76-22.09-67.07-29.65-96.77-1.82-7.15-4.36-14.36,6.26-12.82,31.4,11.06,63.96,19.06,95.38,29.98,2.93,1.02,11.29,3.25,13.03,4.95ZM145,83.71l-88.27-27.25,26.16,87.17,15.87-23.89c1.3-1.45,3.38-2.49,5.33-2.29,3.81.4,26.04,26.32,31.11,30.06,1.27,1.02,1.79.12,2.75-.54,3.06-2.11,8-8.1,10.24-11.36-.39-2.23-23.34-22.21-26.66-26.8-9.1-12.54,17.51-17.28,23.47-25.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.54,27.57c-1.02,3.28-7.59,2.92-9.27-.54-.95-1.95-1-23.42,0-25.08,2.06-3.45,9.28-1.96,9.28,1.64,0,4.86.99,20.81,0,23.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.94,10.9c3.27-.3,18.71,15.42,18.92,18.94.25,4.35-4.09,5.89-7.62,4.25-1.01-.47-15.35-14.8-15.83-15.81-1.62-3.46,1.25-7.08,4.54-7.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.78,55.36c-2.82-.79-3.95-6.65-1.19-8.82,1.98-1.56,19.54-2.56,22.51-1.59,6.79,2.21,3.75,10.42-.61,10.42-4.62,0-17.4.93-20.71,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.49,11.96c5.92-1.24,8.35,2.63,5.6,7.84-.61,1.15-12.07,12.79-12.95,13.19-3.41,1.56-8.12.79-8.46-3.42-.21-2.62,12.69-16.95,15.81-17.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.31,86.69c-4.65-4.6,7.97-15.97,11.69-18.82,4.63-3.54,7.13-3.43,9.6,2.37.16.84-.26,1.49-.55,2.22-.34.83-10.61,12.46-11.73,13.42-2.39,2.07-6.58,3.21-9.01.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145,83.71c-5.96,7.82-32.57,12.56-23.47,25.1,3.33,4.59,26.27,24.57,26.66,26.8-2.24,3.26-7.18,9.25-10.24,11.36-.96.66-1.48,1.56-2.75.54-5.06-3.75-27.29-29.66-31.11-30.06-1.95-.21-4.03.84-5.33,2.29l-15.87,23.89-26.16-87.17,88.27,27.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/Cursor.436afc5c2ceef33a4592acaee6f4cf79.svg";
export { ForwardRef as ReactComponent };